export function NativeAppleSignInButton(
  _props: Readonly<{ disabled: boolean; onPress: () => void }>
) {
  return null;
}
